export default function OnsiteIcon({ width = "40px", stroke = "#667085" }) {
    return (

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.666 18C15.252 16.9 14.201 16.113 12.956 16.113H10.044C8.799 16.113 7.748 16.9 7.334 18M20.778 4.111L18.556 6.333L17.222 5M15 4H7C4.791 4 3 5.791 3 8V17C3 19.209 4.791 21 7 21H16C18.209 21 20 19.209 20 17V9M13.091 9.68401C13.9697 10.5627 13.9697 11.9873 13.091 12.866C12.2123 13.7447 10.7877 13.7447 9.90902 12.866C9.03034 11.9873 9.03034 10.5627 9.90902 9.68401C10.7877 8.80533 12.2123 8.80533 13.091 9.68401ZM19 9C16.791 9 15 7.209 15 5C15 2.791 16.791 1 19 1C21.21 1 23 2.791 23 5C23 7.209 21.21 9 19 9Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


    );
}